

function Placements() {
  return <div>placements</div>
}

export default Placements
